import { cn } from '../lib/cn.js'

/**
 * Título de seção em Anton, caixa alta, alternando fundo conforme o guia.
 * As três variantes existem para alternar ao descer o cardápio — e todas
 * passam contraste AA (medidas: preto/laranja 5.82, preto/amarelo 13.7,
 * amarelo/preto 13.7, branco/laranja 3.37 só em display ≥24px, que é o
 * tamanho mínimo deste componente).
 */
export type SectionTitleProps = {
  children: React.ReactNode
  variante?: 'laranja' | 'amarelo' | 'preto' | 'vazado' | undefined
  tamanho?: 'sm' | 'md' | 'lg' | undefined
  id?: string | undefined
  acao?: React.ReactNode | undefined
  className?: string | undefined
}

export function SectionTitle({
  children,
  variante = 'laranja',
  tamanho = 'md',
  id,
  acao,
  className,
}: SectionTitleProps) {
  return (
    <div className={cn('du-titulo-secao', `du-titulo-secao--${variante}`, `du-titulo-secao--${tamanho}`, className)}>
      <h2 id={id} className="du-titulo-secao__texto">
        {children}
      </h2>
      {acao ? <div className="du-titulo-secao__acao">{acao}</div> : null}
    </div>
  )
}
